
<!--
<div class="page-banner">

    <div class="banner-container">
        <h1>Engineering<br>Delivered.</h1>
        <p>From architecture to deployment, we deliver performant, maintainable solutions designed for real world scale.</p>
    </div>
</div>
-->
<div class="page-content">

    <div class="page-wrapper service-wrapper">

        <div class="sticky-bar" id="sticky-bar">
            <div class="sticky-list" id="sticky-list" [ngClass]="{'fixed' : fixedList, 'absolute' : absoluteList}">
                @for (item of serviceList; track item.id) {
                <p [ngClass]="{'active' : item.active}" (click)="selectServiceItem(item)">{{item.title}}</p>
                }
            </div>
        </div>

        <div class="info-column">
            <div class="info-list">
                @for (item of serviceList; track item.id; let idx = $index) {
                <div class="info-item" id="{{item.id}}" [ngClass]="{'active' : item.active}">
                    <p class="item-number">{{idx + 1}}.</p>
                    <div class="item-content">
                        <h2>{{item.title}}</h2>
                        <p>{{item.description}}</p>
                    </div>
                </div>
                }
            </div>
        </div>

    </div>

      <app-get-demo-form inViewport> </app-get-demo-form>

</div>